import getGettingStartedGuide from '../helpers/getGettingStartedGuide';

const MAPPING = {
    gettingStarted: getGettingStartedGuide
}

export default function(type) {
    return MAPPING[type]();
}